module.exports = __webpack_public_path__ + "static/media/Friezer.6db78109.mp3";